export class DisplayAndSelectModel {
  itemId: number;
  value?: string;
  displayName: string;
  description?: string;
  imgUrl?: string;
}

export class AnswerDisplayAndSelectModel {
  action: AnswerModalTypeEnum;
  selectedItem: DisplayAndSelectModel = new DisplayAndSelectModel();
}

export enum AnswerModalTypeEnum {
  Selected = 'Selected',
  Reset = 'Reset',
  Cancel = 'Cancel'
}
